"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitch = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const theme_1 = __importDefault(require("../styles/theme"));
const typography_1 = require("../styles/typography");
const utils_1 = require("../lib/utils");
const types_1 = require("../lib/types");
const label_1 = __importStar(require("./label"));
const switchHandleStyles = styled_components_1.css `
  content: '';
  background: ${(props) => props.theme.colors.white};
  border-radius: 8px;
  display: block;
  height: 16px;
  width: 16px;
`;
const switchLabelStyles = styled_components_1.css `
  ${typography_1.defaultText}

  background: transparent;
  border-radius: 0;
  color: ${(props) => props.theme.colors.white};
  display: block;
  height: auto;
  width: auto;
`;
const StyledRoot = styled_components_1.default.div `
  display: inline-flex;
  align-items: center;
`;
const StyledWrapper = styled_components_1.default.span `
  display: inline-block;
  position: relative;

  ${label_1.StyledLabel} + & {
    margin-left: ${(props) => props.theme.spacing.xs};
  }
`;
const StyledCheckBoxLabel = styled_components_1.default.label `
  border-radius: 20px;
  background: ${theme_1.default.colors.borderDefault};
  cursor: pointer;
  padding: ${(props) => props.messages.on || props.messages.off ? '5px 9px' : '3px 5px'};
  align-items: ${(props) => props.messages.on || props.messages.off ? 'center' : 'normal'};

  display: flex;

  transition: background 200ms ease-out;

  &::before {
    ${switchHandleStyles}
  }
  &::after {
    content: '${(props) => props.messages.off}';
    ${switchLabelStyles}
    padding: 0px ${(props) => props.messages.on || props.messages.off ? '4px' : '12px'};
    line-height: 18px;
  }

  ${(props) => props.disabled &&
    `
    background: ${props.theme.colors.backgroundInactive};
    cursor: inherit;
  `}
`;
const StyledCheckBox = styled_components_1.default.input `
  cursor: pointer;
  opacity: 0;
  position: absolute;
  z-index: 1;

  ${(props) => props.disabled &&
    `
    cursor: inherit;
  `}

  &:focus-visible + label {
    outline: ${theme_1.default.outline};
    outline-offset: 1px;
  }

  &:checked + ${StyledCheckBoxLabel} {
    background: ${theme_1.default.colors.primaryAccent};

    &::before {
      content: '${(props) => props.messages.on}';
      ${switchLabelStyles}
      padding: 0px ${(props) => props.messages.on || props.messages.off ? '8px' : '12px'};
    }
    &::after {
      ${switchHandleStyles}
      padding: 0px;
    }

    ${(props) => props.disabled &&
    `
      background: ${props.theme.colors.primaryAccentLight};
    `}
  }
`;
const ToggleSwitch = ({ checked, className, defaultChecked, disabled = false, id, innerRef, label = undefined, ariaLabel = undefined, messages = {
    on: 'ON',
    off: 'OFF',
}, name, onChange = utils_1.noop, required, style, value, }) => {
    types_1.accessibleLabelCheck(ariaLabel, label);
    const handleChange = (event) => {
        onChange(event.target.checked, event);
    };
    return (react_1.default.createElement(StyledRoot, { className: className, "data-testid": "toggle-switch-root", style: style },
        label && react_1.default.createElement(label_1.default, { variant: "standalone" }, label),
        react_1.default.createElement(StyledWrapper, null,
            react_1.default.createElement(StyledCheckBox, { checked: checked, defaultChecked: defaultChecked, disabled: disabled, id: id, ref: innerRef, messages: messages, name: name, onChange: handleChange, required: required, type: "checkbox", value: value, "aria-label": ariaLabel || label, "aria-required": required }),
            react_1.default.createElement(StyledCheckBoxLabel, { disabled: disabled, htmlFor: id, messages: messages }))));
};
exports.ToggleSwitch = ToggleSwitch;
exports.default = exports.ToggleSwitch;
